module.exports = "//static.hsappstatic.net/ContentComponents/static-2.69305/img/podcast-zero.png"